import request from '@/utils/request'

let ProductApi = {

  /*分类管理*/
  catList (data, errorback) {
    return request._post('/supplier/product/category/index', data, errorback);
  },
  /*分类添加*/
  catAdd (data, errorback) {
    return request._postBody('/supplier/product/category/add', data, errorback);
  },
  /*分类删除*/
  catDel (data, errorback) {
    return request._post('/supplier/product/category/delete', data, errorback);
  },
  /*分类修改*/
  catEdit (data, errorback) {
    return request._postBody('/supplier/product/category/edit', data, errorback);
  },
  /*产品列表*/
  productList (data, errorback) {
    return request._postBody('/supplier/product/index', data, errorback);
  },
  /*产品选择列表*/
  chooseLists (data, errorback) {
    //return request._postBody('/supplier/product/index', data, errorback);
    return request._postBody('/supplier/data/product/list', data, errorback);
  },
  /*规格选择列表*/
  chooseSpec (data, errorback) {
    return request._post('/supplier/data/product/spec', data, errorback);
  },
  /*新增产品*/
  addProduct (data, errorback) {
    return request._postBody('/supplier/product/add', data, errorback);
  },
  /*产品基础数据*/
  getBaseData (data, errorback) {
    return request._get('/supplier/product/toAdd', data, errorback);
  },
  /*删除产品*/
  delProduct (data, errorback) {
    return request._post('/supplier/product/delete', data, errorback);
  },
  /*产品基础数据*/
  getEditData (data, errorback) {
    return request._get('/supplier/product/edit', data, errorback);
  },
  /*新增产品*/
  invokeFunction (data, errorback) {
    return request._postBody('/supplier/product/invokeFunction', data, errorback);
  },
  /*新增产品*/
  editProduct (data, errorback) {
    return request._postBody('/supplier/product/edit', data, errorback);
  },
  /*新增规格组*/
  addSpec (data, errorback) {
    return request._post('/supplier/product/spec/addSpec', data, errorback);
  },
  /*新增规格值*/
  addSpecValue (data, errorback) {
    return request._post('/supplier/product/spec/addSpecValue', data, errorback);
  },
  /*新增规格组*/
  addProductSpec (data, errorback) {
    return request._post('/supplier/product/spec/addProductSpec', data, errorback);
  },
  /*新增价格政策组*/
  addStage (data, errorback) {
    return request._postBody('/supplier/product/priceStage/addStage', data, errorback);
  },
  delStage (data, errorback) {
    return request._post('/supplier/product/priceStage/deleteStage', data, errorback);
  },
  /*新增价格政策值*/
  addStageValue (data, errorback) {
    return request._postBody('/supplier/product/priceStage/addStageValue', data, errorback);
  },
  /*新增价格政策值*/
  delStageValue (data, errorback) {
    return request._post('/supplier/product/priceStage/deleteStageValue', data, errorback);
  },
  /*新增价格政策组*/
  genPoster (data, errorback) {
    return request._get('/supplier/product/poster', data, errorback);
  },
  /*设备列表不带分页*/
  getList (data, errorback) {
    return request._post('/supplier/data/product/list', data, errorback);
  },
  /*设备列表不带分页*/
  getActiveProductList (data, errorback) {
    return request._post('/supplier/plus.fans.product/list', data, errorback);
  },
  /*设备评论列表*/
  getCommentList (data, errorback) {
    return request._postBody('/supplier/product/comment/index', data, errorback);
  },
  /*获取评论详情*/
  getComment (data, errorback) {
    return request._post('/supplier/product/comment/detail', data, errorback);
  },
  /*获取评论详情*/
  editComment (data, errorback) {
    return request._postBody('/supplier/product/comment/edit', data, errorback);
  },
  /*删除评论*/
  delComment (data, errorback) {
    return request._post('/supplier/product/comment/delete', data, errorback);
  },
  /*得到分类图片*/
  cateImage (data, errorback) {
    return request._post('/supplier/product.category/image', data, errorback);
  },
  /*修改状态*/
  changeStatus (data, errorback) {
    return request._post('/supplier/product/state', data, errorback);
  },
  
  /* 白名单相关API */
  // 获取白名单用户列表
  getWhiteListUsers (data, errorback) {
    return request._post('/supplier/product/whitelist/users', data, errorback);
  },
  // 添加用户到白名单
  addToWhiteList (data, errorback) {
    return request._post('/supplier/product/whitelist/add', data, errorback);
  },
  // 从白名单移除用户
  removeFromWhiteList (data, errorback) {
    return request._post('/supplier/product/whitelist/remove', data, errorback);
  },
  
  /* 黑名单相关API */
  // 获取黑名单用户列表
  getBlackListUsers (data, errorback) {
    return request._post('/supplier/product/blacklist/users', data, errorback);
  },
  // 添加用户到黑名单
  addToBlackList (data, errorback) {
    return request._post('/supplier/product/blacklist/add', data, errorback);
  },
  // 从黑名单移除用户
  removeFromBlackList (data, errorback) {
    return request._post('/supplier/product/blacklist/remove', data, errorback);
  },
  
  /* 用户搜索API */
  // 搜索用户
  searchUsers (data, errorback) {
    return request._post('/supplier/user/search', data, errorback);
  }
}

export default ProductApi;



// WEBPACK FOOTER //
// ./src/api/product.js